import { gql } from '@apollo/client';

export const SUBMIT_FEEDBACK_SIGNAL = gql`
    mutation submitFeedbackSignal($postId: ID!, $signal: FeedbackSignal!) {
        submitFeedbackSignal(postId: $postId, signal: $signal)
    }
`;
